export const SET_ESIG_NEXT_STEP = 'SET_ESIG_NEXT_STEP';

export const eSigNextStep = (value) => ({
	type: SET_ESIG_NEXT_STEP,
	value,
});

export const SET_PERSONAL_PORTFOLIO_FLOW_DATA = 'SET_PERSONAL_PORTFOLIO_FLOW_DATA';

export const setPersonalPortfolioFlowData = (value) => ({
	type: SET_PERSONAL_PORTFOLIO_FLOW_DATA,
	value,
});
